<div class="d-flex justify-content-between">
  <ng-content></ng-content>
  <i *ngIf="order==''" class="mdi mdi-menu-swap text-gray-500 f-18"></i>
  <i *ngIf="order=='asc'" class="mdi mdi-menu-up f-18"></i>
  <i *ngIf="order=='desc'" class="mdi mdi-menu-down f-18"></i>
</div>